import { ReactNode } from 'react';
import _ from 'lodash';
import { Box } from '@mui/material';
import { ExclusiveCreatorToggle } from '@client/new/components/PPC/ExclusiveCreatorToggle';

type FeaturesConfig = {
  component: ReactNode;
};

type getFeatureSettingsConfigProps = {
  influencerId: number;
  canConvertToPPC: boolean;
  visibility: string;
  subscriptionMonthlyPrice: number | null;
  subscriptionAnnualPrice: number | null;
  refetch: () => void;
};

const getFeatureSettingsConfig = (
  props: getFeatureSettingsConfigProps,
): FeaturesConfig[] => [
  {
    component: (
      <ExclusiveCreatorToggle
        influencerId={props.influencerId}
        canConvertToPPC={props.canConvertToPPC}
        visibility={props.visibility}
        subscriptionMonthlyPrice={props.subscriptionMonthlyPrice}
        subscriptionAnnualPrice={props.subscriptionAnnualPrice}
        refetch={props.refetch}
      />
    ),
  },
];

type OneTimeActionsProps = getFeatureSettingsConfigProps;

export const OneTimeActions = (props: OneTimeActionsProps) => {
  const features = getFeatureSettingsConfig(props);

  if (_.isEmpty(features)) {
    return null;
  }

  return (
    <div>
      {features.map(({ component }, index) => (
        <Box key={index}>{component}</Box>
      ))}
    </div>
  );
};
